module.exports = __webpack_public_path__ + "img/hr-train-wheels-shadow-4.08770794.png";